import React from 'react';
import { ArrowRight, Zap } from 'lucide-react';
import { SlideLayout } from './SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function CoverSlide(props: SlideProps) {
  return <SlideLayout {...props} theme="brand" data-id="element-26">
      <div className="flex flex-col items-start max-w-4xl" data-id="element-27">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-indigo-100 text-sm font-medium mb-8 backdrop-blur-sm" data-id="element-28">
          <Zap className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-29" />
          <span data-id="element-30">The Future of Assessment Creation</span>
        </div>

        <h1 className="text-6xl md:text-8xl font-bold text-white mb-8 tracking-tight leading-tight" data-id="element-31">
          5 Weeks <span className="text-indigo-200" data-id="element-32">to</span>
          <br data-id="element-33" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-emerald-300" data-id="element-34">
            30 Seconds
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-indigo-100 max-w-2xl leading-relaxed mb-12" data-id="element-35">
          EduAssess uses advanced AI to transform any content into professional
          assessments, question papers, and branded exports instantly.
        </p>

        <button onClick={props.onNext} className="group flex items-center gap-3 bg-white text-indigo-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-indigo-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-36">
          See the Pitch
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-37" />
        </button>
      </div>
    </SlideLayout>;
}